module.exports = __webpack_public_path__ + "static/media/21ECLAC31.f28f1863.jpg";